import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { AppCommonModule } from '@common/app-common.module'
import { ElectronicProcessBooksComponent } from './electronic-process-books.component'
import { ElectronicProcessBookViewerComponent } from './electronic-process-book-viewer.component'

/** Livro eletrônico do processo (spec 001): geração, histórico e visualizador com pdf.js. */
@NgModule({
	declarations: [ElectronicProcessBooksComponent, ElectronicProcessBookViewerComponent],
	imports: [CommonModule, FormsModule, AppCommonModule],
	exports: [ElectronicProcessBooksComponent, ElectronicProcessBookViewerComponent]
})
export class ElectronicProcessBooksModule {}
